import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { contentGlobalSuccess } from '../../../../content.error';
import { fb } from '../../../../../shared/shared.global-service';
import { Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { ServiceDataShareStore } from '../service-data-share.store';
import { ServiceDataShareObject } from '@libs/types/src/services/object-type/service/service-data-share.object';
import {
    getFolderDashboardWidgetsEnumOptionsToShare,
} from '@libs/types/src/services/enum/folder-dashboard-widgets.enum';
import {
    ServiceDataShareCreateInput,
} from '@libs/types/src/services/input-type/services/service-data-share.create-input';
import {
    ServiceDataShareUpdateInput,
} from '@libs/types/src/services/input-type/services/service-data-share.update-input';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import {
    EmploymentTypeSelectInputComponent,
} from '../../../../../../components/kit/input/employment-type-select-input/employment-type-select-input.component';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { tableImports } from '../../../../../shared/components/kit/table/table.component';

@Component({
    selector: 'app-service-data-share-dialog',
    templateUrl: './service-data-share-dialog.component.html',
    providers: [ServiceDataShareStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectInputComponent,
        EmploymentTypeSelectInputComponent,
        CheckInputComponent,
        tableImports,
    ],
})
export class ServiceDataShareDialogComponent extends BaseDialogComponent implements OnInit {
    protected readonly store = inject(ServiceDataShareStore);

    protected form = fb.group({
        serviceToShareId: fb.control<number | null>(null, [Validators.required]),
        employmentNames: fb.control<string[]>([]),
        onlyMarkedFolders: fb.control<boolean>(false),
        onlyRead: fb.control<boolean>(false),
        widgets: fb.control<string[]>([]),
    });

    share: ServiceDataShareObject | null = null;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.share = this.dialogConfig.data.share;
        if (this.share) {
            this.form.patchValue({
                ...this.share,
            });
        }
    }

    override async save() {
        const serviceId = this.store.serviceId();
        if (isInvalid(this.form) || !serviceId) return;

        if (!this.share) {
            const data = {
                ...this.form.value,
                serviceId,
            } as ServiceDataShareCreateInput;
            await this.store.api.createServiceDataShare(data);
            contentGlobalSuccess.next('common.created');
        } else {
            const data = {
                id: this.share.id,
                ...this.form.value,
                serviceId,
            } as ServiceDataShareUpdateInput;
            await this.store.api.updateServiceDataShare(data);
            contentGlobalSuccess.next('common.updated');
        }
        this.dialogRef.close();
    }

    protected readonly folderDashboardWidgetsEnumOptionsToShare = computed(() =>
        getFolderDashboardWidgetsEnumOptionsToShare(this.store.sourceService()?.type),
    );
}
